import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClientHelperService } from "./http-client-helper.service";
import { SupersetTokenResponse } from "../dashboard/models/dashboard-embed";

@Injectable({
  providedIn: 'root'
})
export class ApiClientDashboardService {
  constructor(private httpClientHelper: HttpClientHelperService) { }

  private readonly controller = 'dashboard';

  /** Legacy per-type dashboard actions: each returns a JSON string (Looker signed URL). */
  generateDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetMainEmbedUrl`);
  }

  generateCMPDashboardUrl(): Observable<string> {
    return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetCmpEmbedUrl`);
  }

  generateDSRAuditDashboardUrl(): Observable<string> {
    return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetDsrAuditLogEmbedUrl`);
  }

  generateAssessmentsDashboardUrl(): Observable<string> {
    return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetAssessmentsEmbedUrl`);
  }

  generateRiskEmbedDashboardEmbedUrl(): Observable<string> {
    return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetRiskEmbedUrl`);
  }

  generateAiGovDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetAIGovEmbeddedUrl`);
  }
  
  generateGovDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetGovernanceEmbeddedUrl`);
  }

  generateTPRMDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetTPRMEmbeddedUrl`);
  }

  generateDsrCaliforniaDropDashboardUrl(): Observable<string> {
      return this.httpClientHelper.invokePostAuth<string>(`${this.controller}/GetDsrCaliforniaDropEmbedUrl`);
  }

  getSupersetToken(dashboardUuid: string): Observable<SupersetTokenResponse> {
    return this.httpClientHelper.invokePostAuth<SupersetTokenResponse>(`dashboards/${encodeURIComponent(dashboardUuid)}/token`);
  }
}
